import { Component, OnInit } from '@angular/core';

import { Data2Service } from '../../common/data2.service';
import { Company } from '../company.model';

@Component({
	selector: 'app-company-list',
	templateUrl: './company-list.component.html',
	styleUrls: ['./company-list.component.css'],
})
export class CompanyListComponent implements OnInit {
	loader = false;
	companies: Array<Company> = [];
	tableRows = [
		{
			id: 'name',
			name: 'Nazwa',
		},
	];

	constructor(private readonly api: Data2Service) {}

	ngOnInit(): void {
		this.loader = true;
		this.loadData();
	}

	private loadData() {
		this.api.get('/company/', (result, error) => {
			this.companies = result.data;
			this.loader = false;
		});
	}
}
